import React, { useState, useMemo } from 'react';
import ReusableTable from '../../reusableTable/index';
import {softDeleteUser, disableUser} from '../../../../../client/users/index'
import ModalDelete from '../../../../shared/modals/modalDelete';
import ModalSuccess from '../../../../shared/modals/modalSuccess';
import ModalEditProvider from '../../../../shared/modals/editUsers/editProvider';

const ProviderUserTable = ({
  recordsPerPage,
  currentPage,
  setCurrentPage,
  searchTerm,
  providerUsers,
  setProviderUsers,
  loading,
  error,
  onRefresh
}) => {

  const [isDeleting, setIsDeleting] = useState(false);
  const [isDisabling, setIsDisabling] = useState(false);
  const [deleteError, setDeleteError] = useState(null);
  const [disableError, setDisableError] = useState(null);
  const [showModalDelete, setShowModalDelete] = useState(false);
  const [showModalSuccess, setShowModalSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [userToDelete, setUserToDelete] = useState(null);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [userToEdit, setUserToEdit] = useState(null);


  
  const handleDeleteClick = (userId) => {
    setUserToDelete(userId);
    setShowModalDelete(true);
  };


  const handleEditClick = (user) => {
    setUserToEdit(user);
    setShowModalEdit(true);
  };

  const handleCloseEditModal = () => {
    setShowModalEdit(false);
    setUserToEdit(null);
  };

const handleSaveEdit = (editedUser) => {

  setShowModalEdit(false);
  setUserToEdit(null);
  onRefresh();
};

  const handleDisableClick = async (userId) => {
    try {
      setIsDisabling(true);
      setDisableError(null);
      
      const response = await disableUser(userId);
      
      if (response.status === 200) {
        setSuccessMessage(response.data.message);
        setShowModalSuccess(true);
        
        onRefresh();
      }
    } catch (err) {
      setDisableError(err.response?.data?.message || 'Error al cambiar el estado del usuario');
    } finally {
      setIsDisabling(false);
    }
  };

  const handleConfirmDelete = async () => {
    if (!userToDelete) return;
    
    try {
      setIsDeleting(true);
      setDeleteError(null);
      
      const response = await softDeleteUser(userToDelete);
      
      if (response.status === 200) {
        setSuccessMessage('Usuario proveedor eliminado correctamente');
        setShowModalSuccess(true);
        onRefresh(); 
      }
    } catch (err) {
      setDeleteError(err.response?.data?.message || 'Error al eliminar el usuario');
    } finally {
      setIsDeleting(false);
      setShowModalDelete(false);
      setUserToDelete(null);
    }
  };

  const handleCloseModal = () => {
    setShowModalDelete(false);
    setUserToDelete(null);
  };

  const handleCloseSuccessModal = () => {
    setShowModalSuccess(false);
    setSuccessMessage('');
  };



    const formattedData = useMemo(() => {
      if (!providerUsers) return [];
      
      return providerUsers.map(user => ({
        id: user.id,
        fullName: user.name || '',
        email: user.email || '',
        charge: user.charge || '',
        phone: user.contact_number || '',
        order_level: user.order_level || '',
        category: user.category || '',
        subtypes: user.subtype ? user.subtype.map(st => st.name).join(', ') : '',
        supplier: user.supplier?.name || '',
        supplierId: user.supplier?.id || '', 
        enabled: user.enabled
      }));
    }, [providerUsers]);

  const filteredData = useMemo(() => {
    if (!searchTerm) return formattedData;
    
    const lowerSearch = searchTerm.toLowerCase();
    return formattedData.filter(user => 
      Object.values(user).some(
        val => val && val.toString().toLowerCase().includes(lowerSearch)
    ));
  }, [formattedData, searchTerm]);

  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * recordsPerPage;
    const endIndex = startIndex + recordsPerPage;
    return filteredData.slice(startIndex, endIndex);
  }, [filteredData, currentPage, recordsPerPage]);

  const columns = useMemo(
    () => [
      {
        Header: '#',
        accessor: 'id',
        style: { minWidth: '50px' },
        Cell: ({ row }) => (currentPage - 1) * recordsPerPage + row.index + 1,
      },
      { Header: 'Nombre y apellido', accessor: 'fullName', style: { minWidth: '260px' } },
      { Header: 'Proveedor', accessor: 'supplier', style: { minWidth: '200px' } },
      { Header: 'Correo institucional', accessor: 'email', style: { minWidth: '260px' } },
      { Header: 'Cargo', accessor: 'charge', style: { minWidth: '140px' } },
      { Header: 'Celular', accessor: 'phone', style: { minWidth: '140px' } },
      { Header: 'Categoría', accessor: 'category', style: { minWidth: '140px' } },

      {
        Header: 'Inhabilitar',
        accessor: 'enabled',
        style: { minWidth: '127px' },
        Cell: ({row}) => (
          <div className="flex items-center justify-center">
            <button
              onClick={() => handleDisableClick(row.original.id)}
              
              className={`p-2 flex justify-center items-center  rounded-[4px]  border-[1px] w-[49px] h-[37px]
                ${row.original.enabled === false ? 'bg-[#007696] border-[#007696]' : 'bg-[#EFEEF7] border-[#D9D9D9]'
              } 
                `}>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.3346 17.3254L2.68384 1.66663L1.66797 2.67456L4.00924 5.01583C2.95108 6.39303 2.37645 8.08065 2.37432 9.81742C2.37432 14.1825 5.94575 17.7539 10.3108 17.7539C12.1203 17.7539 13.7791 17.1428 15.1124 16.119L17.3267 18.3333L18.3346 17.3254ZM10.3108 16.1666C6.80289 16.1666 3.96162 13.3254 3.96162 9.81742C3.96162 8.4444 4.40606 7.1825 5.1521 6.15075L13.9775 14.9761C12.9136 15.7541 11.6288 16.1713 10.3108 16.1666ZM7.27114 4.23805L6.12035 3.07139C7.33463 2.32536 8.77114 1.88091 10.3108 1.88091C14.6759 1.88091 18.2473 5.45234 18.2473 9.81742C18.2473 11.3571 17.8029 12.7936 17.0569 14.0079L15.8902 12.8571C16.3823 11.9523 16.66 10.9206 16.66 9.81742C16.66 6.30948 13.8188 3.46821 10.3108 3.46821C9.20765 3.46821 8.1759 3.74599 7.27114 4.23805Z" 
                  fill={row.original.enabled === false ? "white" : "black"}/>
                </svg>
            </button>
          </div>
        )
      },
      {
        Header: 'Editar',
        style: { minWidth: '127px' },
        Cell: ({row}) => (
          <div className="flex items-center justify-center">
        <button
          onClick={() => handleEditClick(row.original)}
          className="p-2 flex justify-center items-center bg-[#EFEEF7] rounded-[4px] border-[#D9D9D9] border-[1px] w-[49px] h-[37px] "
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.333 16.048L16.57 3.81004C17.0534 3.34741 17.6988 3.09245 18.3679 3.09976C19.037 3.10707 19.6767 3.37608 20.1499 3.84917C20.6231 4.32226 20.8923 4.96183 20.8998 5.63093C20.9073 6.30003 20.6525 6.94547 20.19 7.42904L7.951 19.667C7.6718 19.9463 7.31619 20.1366 6.929 20.214L3 21L3.786 17.07C3.86345 16.6828 4.05378 16.3272 4.333 16.048Z" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M14.5 6.5L17.5 9.5" stroke="black" strokeWidth="2"/>
          </svg>
        </button>
          </div>
        )
      },
      {
        Header: 'Eliminar',
        accessor: 'delete',
        style: { minWidth: '127px' },
        Cell: ({row}) => (
          <div className="flex items-center justify-center">
            <button
              onClick={() => handleDeleteClick(row.original.id)}
              disabled={isDeleting}
              className={`p-2 flex justify-center items-center bg-[#EFEEF7] rounded-[4px] border-[#D9D9D9] border-[1px] w-[49px] h-[37px] ${
                isDeleting ? 'opacity-50 cursor-not-allowed' : ''
              }`}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.7008 3.10083L12.945 4.79167H16.25C16.4158 4.79167 16.5747 4.85751 16.6919 4.97472C16.8092 5.09193 16.875 5.25091 16.875 5.41667C16.875 5.58243 16.8092 5.7414 16.6919 5.85861C16.5747 5.97582 16.4158 6.04167 16.25 6.04167H15.6092L14.8817 14.5292C14.8375 15.0458 14.8017 15.4708 14.7442 15.8142C14.6858 16.1717 14.5967 16.4917 14.4225 16.7883C14.149 17.2543 13.7424 17.6278 13.255 17.8608C12.945 18.0083 12.6183 18.0692 12.2567 18.0975C11.9092 18.125 11.4833 18.125 10.965 18.125H9.035C8.51667 18.125 8.09083 18.125 7.74333 18.0975C7.38167 18.0692 7.055 18.0083 6.745 17.8608C6.25757 17.6278 5.85098 17.2543 5.5775 16.7883C5.4025 16.4917 5.315 16.1717 5.25583 15.8142C5.19833 15.47 5.1625 15.0458 5.11833 14.5292L4.39083 6.04167H3.75C3.58424 6.04167 3.42527 5.97582 3.30806 5.85861C3.19085 5.7414 3.125 5.58243 3.125 5.41667C3.125 5.25091 3.19085 5.09193 3.30806 4.97472C3.42527 4.85751 3.58424 4.79167 3.75 4.79167H7.055L7.29917 3.10083L7.30833 3.05C7.46 2.39167 8.025 1.875 8.73333 1.875H11.2667C11.975 1.875 12.54 2.39167 12.6917 3.05L12.7008 3.10083ZM8.3175 4.79167H11.6817L11.4683 3.31167C11.4283 3.1725 11.3267 3.125 11.2658 3.125H8.73417C8.67333 3.125 8.57167 3.1725 8.53167 3.31167L8.3175 4.79167ZM9.375 8.75C9.375 8.58424 9.30915 8.42527 9.19194 8.30806C9.07473 8.19085 8.91576 8.125 8.75 8.125C8.58424 8.125 8.42527 8.19085 8.30806 8.30806C8.19085 8.42527 8.125 8.58424 8.125 8.75V12.9167C8.125 13.0824 8.19085 13.2414 8.30806 13.3586C8.42527 13.4758 8.58424 13.5417 8.75 13.5417C8.91576 13.5417 9.07473 13.4758 9.19194 13.3586C9.30915 13.2414 9.375 13.0824 9.375 12.9167V8.75ZM11.875 8.75C11.875 8.58424 11.8092 8.42527 11.6919 8.30806C11.5747 8.19085 11.4158 8.125 11.25 8.125C11.0842 8.125 10.9253 8.19085 10.8081 8.30806C10.6908 8.42527 10.625 8.58424 10.625 8.75V12.9167C10.625 13.0824 10.6908 13.2414 10.8081 13.3586C10.9253 13.4758 11.0842 13.5417 11.25 13.5417C11.4158 13.5417 11.5747 13.4758 11.6919 13.3586C11.8092 13.2414 11.875 13.0824 11.875 12.9167V8.75Z" fill="black"/>
            </svg>
            </button>
          </div>
        )
      },


    ],
    [currentPage, recordsPerPage, isDeleting]
  );

  return (
    <>

    <ReusableTable
      columns={columns}
      data={paginatedData}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      recordsPerPage={recordsPerPage}
      totalRecords={filteredData.length}
      loading={loading}
      error={error}
    />

      
      <ModalDelete 
        showModalDelete={showModalDelete}
        closeModal={handleCloseModal}
        accept={handleConfirmDelete}
        textType="usuario proveedor"
        pronoun="el"
      />

      <ModalSuccess 
        showModalSuccess={showModalSuccess}
        closeModalSuccess={handleCloseSuccessModal}
        fill="green" 
        text={successMessage}
      />

      <ModalEditProvider
        showModal={showModalEdit}
        user={userToEdit}
        onClose={handleCloseEditModal}
        onSave={handleSaveEdit}
        setSuccessMessage={setSuccessMessage}
        setShowModalSuccess={setShowModalSuccess}
      />

      
    </>
  );
};

export default ProviderUserTable;